import deepmerge from 'deepmerge';
import React, { Context, createContext, useContext, ReactNode } from 'react';

const ConfigContext: Context<unknown> = createContext<unknown>({});

export interface BaseConfig extends Record<string, unknown> {
    bankregnr?: string;
}

interface PropConfig extends BaseConfig {
    data?: BaseConfig;
    bankregnr?: string;
}

export interface Props<T extends PropConfig> {
    state: T;
    children?: ReactNode;
}

const getConfig = <T extends PropConfig>(config: T): BaseConfig => {
    if (config?.data) {
        return {
            ...config.data,
            bankregnr: config.bankregnr,
        };
    }
    if (config) {
        return config;
    }
    return {};
};

export default <T extends PropConfig>(config: T): React.FC<Props<T>> => {
    return ({ state, children }) => {
        const overrides = getConfig(state);
        const mergedConfig = deepmerge<BaseConfig>(config ?? {}, overrides as T);
        return <ConfigContext.Provider value={mergedConfig}>{children}</ConfigContext.Provider>;
    };
};

export function useConfig<T>(): T {
    return useContext<T>(ConfigContext as Context<T>);
}
